<template>
  <section class="bg-footer-bg text-footer-text pt-20 pb-12 px-4">
    <div class="max-w-screen-lg mx-auto">
      <article class="flex justify-between items-end pb-8">
        <div>
          <a href="https://www.esri.es/es-es/home" target="_blank">
            <LogoWhere />
          </a>
        </div>

        <div class="flex">
          <a
            href="http://www.facebook.com/pages/Esri-Espa%C3%B1a-Geosistemas/189806744376056"
            target="_blank"
          >
            <div class="social-item social-fb">
              <BaseIcon :name="['fab', 'facebook-f']" />
            </div>
          </a>

          <a href="http://twitter.com/Esri_Spain" target="_blank">
            <div class="social-item social-tw">
              <BaseIcon :name="['fab', 'twitter']" />
            </div>
          </a>

          <a href="https://www.linkedin.com/company/esri-spain" target="_blank">
            <div class="social-item social-li">
              <BaseIcon :name="['fab', 'linkedin-in']" />
            </div>
          </a>

          <a href="http://www.youtube.com/user/esriSpainTV" target="_blank">
            <div class="social-item social-yt">
              <BaseIcon :name="['fab', 'youtube']" />
            </div>
          </a>
        </div>
      </article>

      <article class="text-sm pt-8 border-t border-footer-text">
        <div class="md:flex md:justify-center">
          <div class="px-2 py-2 md:px-8">
            <a
              href="https://www.esri.com/content/distributor-sites/esri-es/es-es/privacy/aviso-legal"
              target="_blank"
              class="footer-link"
            >
              Aviso Legal
            </a>
          </div>

          <div class="px-2 py-2 md:px-8">
            <a
              href="https://www.esri.com/content/distributor-sites/esri-es/es-es/privacy/cookies"
              target="_blank"
              class="footer-link"
            >
              Cookies
            </a>
          </div>

          <div class="px-2 py-2 md:px-8">
            <a
              href="https://www.esri.com/content/distributor-sites/esri-es/es-es/privacy/overview"
              target="_blank"
              class="footer-link"
            >
              Privacidad
            </a>
          </div>

          <div class="px-2 py-2 md:px-8">
            <a
              href="https://www.esri.com/content/distributor-sites/esri-es/es-es/acerca-de/contacto/contacto"
              target="_blank"
              class="footer-link"
            >
              Contacto
            </a>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import LogoWhere from '@/components/LogoWhere'

export default {
  components: { LogoWhere },
}
</script>

<style scoped>
section {
  background: #f8f8f8;
  color: ;
}

.footer-link {
  @apply transition-all duration-300;
}

.footer-link:hover {
  @apply text-secondary-500;
}

.social-item {
  @apply w-10 h-10 text-xl bg-footer-social flex items-center justify-center text-white mx-1 transition-all duration-300;
}

.social-fb:hover {
  background: #005e95;
}

.social-tw:hover {
  background: #59adeb;
}

.social-li:hover {
  background: #127cb3;
}

.social-yt:hover {
  background: #cf2529;
}
</style>
